// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ModifyStopOrder } from '../order-modify/ModifyStopOrder';
import { OrderTypeBase } from './OrderTypeBase';
import { OrderType } from '@shared/utils/Trading/OrderType';
import { StopOrderEdit } from '../order-edit/StopOrderEdit';
export class StopOrderType extends OrderTypeBase {
    constructor() {
        super(StopOrderEdit, ModifyStopOrder);
    }
    // TODO. Remove.
    id() {
        return OrderType.Stop;
    }
}
